// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3Vbhe","actionsCol":"EnrolledClinics_actionsCol__3uPtW"};